import { useState } from 'react'

export function useSideChatSize() {
  const [width, setWidth] = useState(() => {
    return parseInt(localStorage.getItem('sidechat-width') || '320')
  })
  const [height, setHeight] = useState(() => {
    return parseInt(localStorage.getItem('sidechat-height') || '280')
  })
  const [isFullscreen, setIsFullscreen] = useState(() => {
    return localStorage.getItem('sidechat-fullscreen') === 'true'
  })

  const saveWidth = (w: number) => {
    const clamped = Math.max(250, Math.min(window.innerWidth - 100, w))
    setWidth(clamped)
    localStorage.setItem('sidechat-width', String(clamped))
  }

  const saveHeight = (h: number) => {
    const clamped = Math.max(200, Math.min(window.innerHeight - 100, h))
    setHeight(clamped)
    localStorage.setItem('sidechat-height', String(clamped))
  }

  const toggleFullscreen = () => {
    const newState = !isFullscreen
    setIsFullscreen(newState)
    localStorage.setItem('sidechat-fullscreen', String(newState))
  }

  return { width, height, isFullscreen, saveWidth, saveHeight, toggleFullscreen }
}
